import { Box, Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import Chip from "components/Chip";
import TableComponent from "components/TableComponent";
import { Colors } from "constants/colors";
import React from "react";
import { useNavigate } from "react-router-dom";

type props = {
  rows: any;
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  onManage?: any;
};

const CorporateAccounts = ({
  rows,
  count,
  page,
  onPageChange,
  loading,
  onManage,
}: props) => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef[] = [
    {
      flex: 0.4,
      minWidth: 300,
      field: "company",
      headerName: "Company",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              onClick={() => navigate(`/profile-detail/individual/${row?._id}`)}
            >
              <img src={"/static/images/user_placeholder.png"} alt="" />
            </figure>
            <p>
              <b>TechCorp inc.</b>
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 200,
      field: "contact",
      headerName: "Contact",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>John Doe</b>
              john@yopmail.com
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 200,
      field: "cars",
      headerName: "Cars Allocated",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block" style={{ gap: 8 }}>
            <figure
              style={{ borderRadius: 0, minWidth: 30, height: 20, width: 30 }}
            >
              <img src={"/static/images/car.png"} alt="" />
            </figure>{" "}
            <p>20</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "employees",
      headerName: "Employees",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block" style={{ gap: 8 }}>
            <figure
              style={{ borderRadius: 0, minWidth: 20, height: 20, width: 20 }}
            >
              <img src={"/static/images/registrations.png"} alt="" />
            </figure>{" "}
            <p>60</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "billing",
      headerName: "Billing Cycle",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Monthly</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "amount",
      headerName: "Amount",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p color={Colors.primary}>$ 7000</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "outstanding",
      headerName: "Outstanding",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p color={Colors.primary}>$0</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "manager",
      headerName: "Account Manager",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>David Smith</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "actions",

      headerName: "Actions",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Button
              onClick={onManage}
              variant="outlined"
              color="inherit"
              size="small"
            >
              Manage
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default CorporateAccounts;
